import { Component, OnInit, ViewChild } from '@angular/core';
import { GridViewComponent } from '../../grid-view/grid-view.component';
import { GlobalServices } from '../../../services/global.service';
import { MessagingService } from '../../../services/messaging.service';
import { Listing } from '../../../models/listing.model';
import { Languages } from '../../../models/enums.model';
import { DatePipe } from '@angular/common';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { Router } from '@angular/router';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-etender-messages',
  templateUrl: './etender-messages.component.html'
})
export class ETenderMessagesComponent implements OnInit {
  private collection: Listing;
  pageSize = 15;
  public currentLanguage;
  private itemsMenu: MenuItem[] = [];
  @ViewChild('ETenderMessages',{static: false}) gridView: GridViewComponent;
  public currentUser: User = new User();
  private isUserInGroup: boolean;

  constructor(private messagingService: MessagingService, private global: GlobalServices,
    public datepipe: DatePipe, private authenticationService: AuthenticationService,
    private route: Router, private localeService: BsLocaleService,
    private translate: TranslateService)
  {
    this.currentUser = this.authenticationService.currentUserValue;
    //this.currentUser = this.global.user;
  }

  ngOnInit() {

    //this.currentUser = this.authenticationService.currentUserValue;
    this.currentLanguage = this.global.getLanguage() == Languages.Arabic ? "Ar" : "En";
    if (this.currentUser.IsAdmin) {
      this.messagingService.checkUserInSPGroup(this.currentUser.Email, "SCAServices_ETender_MessagingAdmins").subscribe(
        data => this.isUserInGroup = data.Data,
        () => console.log("Something went wrong!!"),
        () => this.loadAdminMessages()
      );
    }
    else {
      this.loadUserMessages();
    }
  }

  loadAdminMessages() {
    if(this.isUserInGroup == true)
    {
      this.messagingService.getAdminETenderMessages(this.currentUser.Email, 0, this.pageSize, this.currentLanguage).subscribe(
        data => this.collection = data.Data,
        () => console.log("Something went wrong!!"),
        () => this.loadAdminCollectionCompleted()
      );
    }
    else
    {
       this.route.navigate(["/workspace"]);
    }
  }

  loadUserMessages() {
    this.messagingService.getUserETenderMessages(this.currentUser.UserId, 0, this.pageSize, this.currentLanguage).subscribe(
      data => this.collection = data.Data,
      () => console.log("Something went wrong!!"),
      () => this.loadUserCollectionCompleted()
    );
  }

  loadUserCollectionCompleted() {
    this.loadItemsMenu();
    this.gridView.loadGrid(this.collection, this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
      "ETenderMessaging/GetUserMessagesPaged?supplierId=" + this.currentUser.UserId +
      "&pageIndex={PAGEINDEX}&pageSize=" + this.pageSize +
      "&lang=" + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En"),
      "SHARED", this.itemsMenu, "", "", 'ETenderMessages');
    this.global.isLoaderEnabled = false;
  }

  loadAdminCollectionCompleted() {
    this.loadItemsMenu();
    this.gridView.loadGrid(this.collection, this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
      "ETenderMessaging/GetAdminMessagesPaged?adminMail=" + this.currentUser.Email +
      "&pageIndex={PAGEINDEX}&pageSize=" + this.pageSize +
      "&lang=" + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En"),
      "SHARED", this.itemsMenu, "", "", 'ETenderMessages');
    this.global.isLoaderEnabled = false;
  }

  loadItemsMenu() {
    this.itemsMenu[0] = new MenuItem();
    this.itemsMenu[0].Title = "Details";
    this.itemsMenu[0].TitleAr = "التفاصيل";
  }

}

export class MenuItem {
  Title: string;
  TitleAr: string;
};
